var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0529 2.29622C10.4048 1.90126 9.59524 1.90126 8.94713 2.29621L2.99359 5.92441C2.37718 6.30007 2 6.97669 2 7.70684V15.9213C2 17.0694 2.91626 18 4.04651 18H15.9535C17.0838 18 18 17.0694 18 15.9213V7.70684C18 6.97669 17.6228 6.30007 17.0064 5.92442L11.0529 2.29622ZM6.59914 9.41026C6.34661 9.23066 5.99859 9.2931 5.82183 9.54956C5.64505 9.80603 5.70647 10.1596 5.959 10.3391L9.67993 12.9846C9.87207 13.1213 10.1279 13.1213 10.3201 12.9846L14.041 10.3391C14.2935 10.1596 14.355 9.80603 14.1782 9.54956C14.0014 9.2931 13.6534 9.23066 13.4009 9.41026L10 11.8282L6.59914 9.41026Z",
    fill: "#9A9FA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/Quotes.32cb4e25b33ea87fc05e156fcf4d9e5a.svg";
export { ForwardRef as ReactComponent };